import PromineoTabs from "components/common/controls/PromineoTabs";
import PanelHeader from "fetaures/docs/HowItWorks/PanelHeader";
import PromineoSimpleDataGrid from "components/common/controls/grid/PromineoSimpleDataGrid";
import SectionLabel from "./SectionLabel";
import { ScrollView } from "devextreme-react";
import { Scrolling } from "devextreme-react/data-grid";
import RequestJsonViewer from "./RequestJsonViewer";
import React from "react";

interface Props {
  data: any;
}

const OutputDataViewer = React.memo((props: Props) => {
  const Header = () => {
    return <PanelHeader stepCount={4} title="Your output data" />;
  };

  const OutputDataView = () => {
    return (
      <div className="flex">
        <div className="w-1/2">
          <SectionLabel label="Table" />
          <ScrollView>
            <div className="max-h-150">
              <PromineoSimpleDataGrid
                classNames="example-data-viewer-grid"
                dataGridOptions={{
                  sorting: { mode: "none" },
                  dataSource: props.data,
                  noDataText: "No Data",
                  style:{"maxHeight": "37.5rem"}
                }}
                
              >
                <Scrolling mode="virtual" rowRenderingMode="virtual" />
              </PromineoSimpleDataGrid>
            </div>
          </ScrollView>
        </div>
        <div className="w-1/2">
          <RequestJsonViewer json={props.data} />
        </div>
      </div>
    );
  };

  return (
    <>
      <PromineoTabs
        tabs={[
          {
            component: OutputDataView,
            title: "Data",
          },
        ]}
        tabsLabel="Viewing mode"
        header={Header}
      />
    </>
  );
});

export default OutputDataViewer;
